export class MaritalStatusRequired extends Error {
  constructor() {
    super('Estado civil é obrigatório')
    this.name = 'MaritalStatusRequired'
  }
}
